import Component from './component';

/**
 * StickyContainer component
 */
export default class StickyContainer extends Component {
    constructor(...args) {
        super(...args);
        this.containerTop = 0;
        this.observer = null;
        return this;
    }

    setStickyPosition(container) {
        // get container and windows dimensions
        const containerRect = container.getBoundingClientRect();
        const containerHeight = container.offsetHeight;
        const windowHeight = window.innerHeight;
        const isNavHidden = $('body').hasClass('nav-hidden');
        var $container = $(container)

        // set container top based on the height of the window and container height
        let containerTop = containerHeight > windowHeight ? windowHeight - containerHeight : 0;
        // if (!isNavHidden) {
        //     containerTop += 56;
        // }

        // Override scroll behavior on QV modal - no scroll
        if ($container.parent().hasClass('qw-buybox')) {
            return;
        }
        container.classList.toggle('is-sticky', containerRect.top <= containerTop);
        if (containerTop !== this.containerTop) {
            container.style.top = `${containerTop}px`; // Fixed position at bottom
            this.containerTop = containerTop;
        }
    }

    observeAttributes(container) {
        // Create a MutationObserver to watch for attribute changes
        this.observer = new MutationObserver(() => {
            this.setStickyPosition(container);
        });

        // Configure the observer to watch for attribute changes and subtree modifications
        const config = { attributes: true, childList: true, subtree: true };

        // Start observing the container element
        this.observer.observe(container, config);
    }

    enable() {
        const container = this.el;
        this.setStickyPosition(container);
        window.addEventListener('scroll', () => this.setStickyPosition(container));
        this.observeAttributes(container); // Start observing attribute changes
    }
}
